<template>
  <div class="article" id="articleRippleWrap">
    <ul>
      <li class="item" v-for="(item, index) in articleList" :key="index">
        <p class="mainTitle" @click="toArticlePage(item.ID)">
          <span>[{{ item.original }}]</span>
          <span v-html="item.mainTitle"></span>
        </p>
        <ul class="tags">
          <li
            v-for="(tag, i) in item.tags"
            :key="i"
            @click="chooseTag(tag)"
            :class="{ active: nowTagName === tag }"
          >
            {{ tag }}
          </li>
        </ul>
        <!-- 文章简介 -->
        <div @click="toArticlePage(item.ID)">
          <div>
            <p class="intro" v-html="item.intro + '...'"></p>
            <div style="box-shadow: inset 0px -10px 15px -10px"></div>
          </div>
          <div class="info">
            <div class="date">更新时间：{{ item.updateDate }}&nbsp;&nbsp;</div>
            <div class="column">
              |&nbsp;&nbsp;分类：
              <span>{{ item.col }}</span>
            </div>
            <div class="floor">
              <span>&nbsp;&nbsp;|&nbsp;&nbsp;# {{ index + 1 }}</span>
            </div>
          </div>
          <p class="readMore" v-if="!toEdit && !isDraft">查看详情...</p>
        </div>
        <!-- 操作按钮 -->
        <div style="float:right">
          <!-- 草稿箱 -->
          <div
            class="more"
            @click="toEditDraft(item.ID)"
            v-if="toEdit && isDraft"
          >
            <span class="info">编辑</span>
          </div>
          <div
            class="delete"
            @click="toDeleteArticle(item.ID, index, 'draft')"
            v-if="toEdit && isDraft"
          >
            <span class="info">删除</span>
          </div>
          <!-- 全部博客 -->
          <div
            class="more"
            @click="toEditArticle(item.ID)"
            v-if="toEdit && isArticle"
          >
            <span class="info">编辑</span>
          </div>
          <div
            class="delete"
            @click="toDeleteArticle(item.ID, index, 'article')"
            v-if="toEdit && isArticle"
          >
            <span class="info">删除</span>
          </div>
        </div>
      </li>
      <!-- <li v-if="!isLoading" style="text-align:center;padding-top:10px">
        {{ "当前页：" + currentPage + " 总页数：" + allPageNum }}
      </li> -->
      <li
        v-if="currentPage == allPageNum && !isLoading && articleList.length"
        style="text-align:center;padding:30px 0;color:'#666666'"
      >
        我是有底线的 (¯^¯ )
      </li>
    </ul>
    <div class="error-wrapper">
      <v-Loading v-show="isLoading"></v-Loading>
      <v-ErrorCom v-show="!isLoading && !articleList.length"></v-ErrorCom>
    </div>
    <v-Alert
      v-show="alertShow"
      :alertInfo="alertInfo"
      @confirm="confirm"
      @cancel="cancel"
    ></v-Alert>
  </div>
</template>

<script>
import { ripple } from "@/assets/script/common";
import Alert from "@/components/common/alert/alert";
import ErrorCom from "@/components/common/error/error";
import Loading from "@/components/common/loading/loading";
import {
  deatroyArticle,
  deatroyDraft,
  queryOneArticle,
  queryOneDraft
} from "@/bmob";

export default {
  data() {
    return {
      alertShow: false,
      alertInfo: {}
    };
  },
  props: {
    articleList: {
      type: Array,
      default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    nowTagName: {
      type: String,
      default: ""
    },
    toEdit: {
      type: Boolean,
      default: false
    },
    isDraft: {
      type: Boolean,
      default: false
    },
    isArticle: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    //总页面数
    allPageNum() {
      return Math.ceil(this.articleCount / this.pageNum);
    }
  },
  methods: {
    chooseTag(itemTag) {
      this.$emit(
        "toTag",
        itemTag ? (itemTag == this.nowTagName ? "" : itemTag) : ""
      );
    },
    toArticlePage(articleId) {
      if (this.isDraft) {
        //如果是草稿箱，则跳转草稿箱的编辑
        this.toEditDraft(articleId);
        return;
      }
      //不是草稿箱就跳转文章内容详情
      //获取用户id
      const userId = this.articleList[0].userId || "";
      //获取关键词
      const keyWord = this.$route.query.keyWord || "";
      let query = { articleId };
      if (userId) {
        query.userId = userId;
      }
      //如果有关键词，带上
      if (keyWord) {
        query.keyWord = keyWord;
      }
      this.$router.push({ path: "/article", query }); //跳转到文章对应的框架
    },
    toEditDraft(id) {
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "draft" }
      });
    },
    toEditArticle(id) {
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "blog" }
      });
    },
    toDeleteArticle(id, index, type) {
      this.alertShow = true;
      this.alertInfo = { id, index, type };
    },
    async confirm(info) {
      let { id, index, type } = info;
      await this.toDeleteFile(id, type); //删除云文件
      if (type === "draft") {
        //从草稿箱删除
        deatroyDraft(id)
          .then(res => {
            this.$emit("showMessage", res);
            this.articleList.splice(index, 1);
            this.alertShow = false;
          })
          .catch(err => {
            this.$emit("showMessage", err);
            this.alertShow = false;
          });
      } else {
        //从全部文章删除
        deatroyArticle(id)
          .then(res => {
            this.$emit("showMessage", res);
            this.articleList.splice(index, 1);
            // 重新获取分类
            this.$emit("getCategories");
            this.alertShow = false;
          })
          .catch(err => {
            this.$emit("showMessage", err);
            this.alertShow = false;
          });
      }
    },
    cancel() {
      this.alertShow = false;
    },
    toDeleteFile(id, type) {
      //删除该文章云文件
      return new Promise((resolve, reject) => {
        let delList = [];
        const del = Bmob.File();
        if (type == "draft") {
          //如果是草稿箱
          //从草稿箱获取指定文章内容
          queryOneDraft(id).then(res => {
            delList = this.getBmobFileList(res.content);
            //传入要删除的文件地址
            delList.length && del.destroy(delList);
          });
        } else {
          //从所有文章中获取指定文章内容
          queryOneArticle(id).then(res => {
            delList = this.getBmobFileList(res.content);
            //传入要删除的文件地址
            delList.length && del.destroy(delList);
          });
        }
        resolve();
      });
    },
    getBmobFileList(content) {
      //获取该文章云文件地址
      const pattern = /!\[(.*?)\]\((.*?)\)/gm;
      const result = [];
      let matcher;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      return result;
    }
  },
  components: {
    "v-Alert": Alert,
    "v-Loading": Loading,
    "v-ErrorCom": ErrorCom
  }
};
</script>

<style lang="less">
@import "../../../assets/style/common.less";
@m26a69a: #26a69a;
@m009688: #009688;
@mdedede: #dedede;
@m383838: #383838;
.article {
  width: 75%;
  position: relative;
  .item {
    padding: 15px 20px 20px;
    border-bottom: 1px solid @mdedede;
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.1);
    }
  }
  .mainTitle {
    font-size: 18px;
    line-height: 30px;
    color: #666;
    cursor: pointer;
    overflow: hidden;
    /* autoprefixer: off */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
    // overflow: hidden;
    // text-overflow:ellipsis;
    // white-space: nowrap;
    &:hover {
      text-decoration: underline;
      color: @m26a69a;
    }
    span {
      color: @m26a69a;
    }
  }
  .subTitle {
    font-size: 16px;
    line-height: 30px;
    color: @m383838;
  }
  ul.tags {
    .clearfixMixin();
    margin-top: 10px;
    li {
      float: left;
      font-size: 12px;
      padding: 5px 10px;
      margin-right: 10px;
      color: #fff;
      background-color: #00b5a3;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        background-color: #f76689;
      }
    }
    .active {
      background-color: #e91e63;
    }
  }
  .intro {
    font-family: "sourcesanspro", "Helvetica Neue", Arial, sans-serif;
    margin-top: 15px;
    font-size: 14px;
    color: #828282;
    line-height: 25px;
    max-height: 25px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    :first-child {
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .readMore {
    color: rgb(0, 181, 163);
    text-decoration: underline;
    cursor: pointer;
    font-size: 13px;
    float: right;
  }
  .info {
    font-family: "sourcesanspro", "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 5px;
    .clearfixMixin();
    .date,
    .column {
      float: left;
      font-size: 12px;
      color: #828282;
    }
  }
  .more,
  .delete {
    display: inline-block;
    color: skyblue;
    border-radius: 2px;
    color: @m26a69a;
    cursor: pointer;
    margin-left: 15px;
    &:hover {
      color: #0d7b71;
    }
  }
  .loadingWrap {
    .icon {
      padding: 0px !important;
    }
  }
  .pagination {
    margin: 50px 0 80px;
    padding: 0 20px;
    .clearfixMixin();
    button {
      background-color: transparent;
      color: #2e9c92;
      font-size: 14px;
      line-height: 30px;
      padding: 0 10px;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.3s;
    }
    .prev:hover,
    .next:hover {
      color: #fff;
      background-color: #2e9c92;
    }
    .prev {
      float: left;
    }
    .next {
      float: right;
    }
    i {
      font-family: sans-serif;
      font-style: normal;
    }
  }
  .floor {
    float: left;
    font-size: 13px;
    color: #828282;
  }
}
@media (max-width: 1024px) {
  .article {
    .item {
      padding: 5px 20px 25px;
    }
    .pagination {
      margin: 50px 0 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// article.vue?27c82aa2